import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import config from 'config';
import { Base64 } from 'js-base64';
import React, { Component } from 'react';
import { toast } from 'react-toastify';
import "Home/CommonResources/NotificationPanel/NotificationModal/UpdateSummary/updatesummary.css";
import SuccessModal from 'Home/CommonResources/SuccessModal/SuccessModal';
import ViewAttachment from 'Home/CommonResources/ViewAttachment/ViewAttachment';
import HomeApiCall from 'HomeApiCall';

export class UpdateSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileInputRef: React.createRef(),
      summaryText: '',
      viewAttachment: false,
      attachmentPath: '',
      attachmentFile: '',
      attachmentFileExtension: '',
      approvingRelease: false,
      existingSummary: {},
      isLoadingExistingSummary: false,
      isAddingReleaseSummary: false,
      currentIndex: 0,
      reloadSummary: false,
      isAddingUpdatingSummary: false,
      isUpdatingSummary: false,
      successModal: false,
      isUpdateSummaryEditable: false,
      uniqueId: null,
      isViewing: false
    };
  }

  componentDidMount() {
    this.apiCallToGetExistingSummary();
  }




  // pmTool_getReleaseSummaryByRelease
  apiCallToGetExistingSummary = async () => {
    this.setState({ isLoadingExistingSummary: true });
    let requestData = {
      "releaseId": this.props.releaseID,
      "uniqueId": "",
      "screenFlag": "notification",
    };
    let jsonResponse = await HomeApiCall.makeApiCall(
      'pmTool_getReleaseSummaryByRelease',
      requestData,
      '/api/projectManagement/Queries/pmTool_DocSEMDashBoard.php'
    );
    if (jsonResponse.expired) {
      setTimeout(() => {
        this.apiCallToGetExistingSummary();
      }, 1000);
    }
    if (jsonResponse.success) {
      if (jsonResponse.APIResult.status === 'success') {
        let existingData = jsonResponse.APIResult.data;



        this.setState({
          existingSummary: existingData,
          isLoadingExistingSummary: false,
        })
      } else {
        this.setState({
          existingSummary: {},
          isLoadingExistingSummary: false,
        });
      }
    } else {
      this.setState({
        existingSummary: {},
        isLoadingExistingSummary: false,
      });
    }
  }

  // apiCallToViewedRelease
  apiCallToViewedRelease = async () => {
    this.setState({ isViewing: true });
    let requestData = {
      "releaseId": this.props.releaseID,
      "userId": config.faculty_id,
    };
    let jsonResponse = await HomeApiCall.makeApiCall(
      'addReadNotificationByUserLogs',
      requestData,
      '/api/projectManagement/Queries/pmTool_DocSEMDashBoard.php'
    );
    if (jsonResponse.expired) {
      setTimeout(() => {
        this.apiCallToViewedRelease();
      }, 1000);
    }
    if (jsonResponse.success) {
      this.setState({
        isViewing: false,
      })
      // if (jsonResponse.APIResult.status === 'success') {
      //   this.setState({
      //     isViewing: false,
      //   })
      // } else {
      //   this.setState({

      //     isViewing: false,
      //   });
      // }
    } else {
      this.setState({
        isViewing: false,
      });
    }
  }


  viewNextImage = () => {
    const { existingSummary, currentIndex } = this.state;
    const keys = Object.keys(existingSummary);

    if (currentIndex < keys.length - 1) {
      this.setState(
        prevState => ({
          currentIndex: prevState.currentIndex + 1
        }),
        () => {
          this.apiCallToViewedRelease();
        }
      );
    }
  };
  viewPreviousImage = () => {
    const { currentIndex } = this.state;

    if (currentIndex > 0) {
      this.setState(prevState => ({
        currentIndex: prevState.currentIndex - 1
      }));
    }
  };

  closeAttachment = () => {
    this.setState({ viewAttachment: false });
  };



  closeSuccessModal = () => {
    this.setState({
      successModal: false,
    });
  }
  handleAttachmentClick = (attachment, filePath) => {
    this.setState({
      viewAttachment: true,
      attachmentPath: filePath,
      attachmentFile: attachment,
      attachmentFileExtension: attachment.substring(attachment.lastIndexOf('.') + 1)
    });
  };


  render() {
    const { existingSummary } = this.state;
    const { currentIndex } = this.state;
    const summaryKeys = Object.keys(this.state.existingSummary);
    let imageUrl = "";
    let summaryText = "";
    // let currentItemUniqueId = null;
    let currentItem = {};

    if (existingSummary && Object.keys(existingSummary).length !== 0) {
      const keys = Object.keys(existingSummary);
      currentItem = existingSummary[keys[currentIndex]];

      imageUrl = `${currentItem.attachmentPath}//${currentItem.attachments}`;
      summaryText = currentItem.summary_text;
      // currentItemUniqueId = currentItem.unique_id;
    }



    return (
      <div className='d-flex flex-column gap-2 workspace-current-modal-mode notification-mobile-mode' style={{
        height: 'calc(100% - 53px)',
        minHeight: "80vh",
        borderRadius: '8px', padding: '24px 24px 0px 24px',
      }}
      >
        {Object.keys(this.state.existingSummary).length > 0 ?
          (!this.state.existingSummary || Object.keys(this.state.existingSummary).length === 0) ?
            <div className='vm_custom_body4'>No Content Summary found.</div>
            :
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '15px', overflowY: 'auto' }}>
              {/* <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', gap: '10px' }}>
                <p className='vm_custom_subtitle3'>Content</p>
              </div> */}
              <div className="content-break-word text-center" style={{ padding: '20px 10px', justifyContent: 'center' }}>
                <p className='vm_custom_body1' style={{ textAlign: 'left' }}>
                  {summaryText}
                </p>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '10px', justifyContent: 'space-between' }}>
                {currentIndex > 0 && (
                  <FontAwesomeIcon onClick={() => this.viewPreviousImage()} icon={['fas', 'chevron-circle-left']} color="#0465AC" style={{ cursor: 'pointer', height: '28px', width: '28px' }} />
                )}
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: '100%' }}>

                  {(() => {
                    const isVideo = /\.(mp4|webm|ogg)$/i.test(imageUrl);
                    return isVideo ? (
                      <video
                        src={imageUrl}
                        controls
                        style={{ maxWidth: '80%', minHeight: '60vh', maxHeight: '90vh' }}
                        onClick={() =>
                          this.handleAttachmentClick(currentItem.attachments, currentItem.attachmentPath + '/')
                        }
                      />
                    ) : (
                      <img
                        src={imageUrl}
                        alt="Carousel Item"
                        style={{ maxWidth: '80%', minHeight: '60vh', maxHeight: '90vh' }}
                        onClick={() =>
                          this.handleAttachmentClick(currentItem.attachments, currentItem.attachmentPath + '/')
                        }
                      />
                    );
                  })()}





                </div>
                {currentIndex < summaryKeys.length - 1 && (
                  <FontAwesomeIcon onClick={() => this.viewNextImage()} icon={['fas', 'chevron-circle-right']} size="lg" color="#0465AC" style={{ cursor: 'pointer', height: '28px', width: '28px' }} />
                )}
              </div>


            </div> :
          <div style={{ marginTop: '50px' }} className='vm_custom_body4'>No Content Summary found.</div>
        }


        {
          this.state.viewAttachment &&
          <ViewAttachment
            viewAttachment={this.state.viewAttachment}
            attachmentPath={this.state.attachmentPath}
            attachmentFile={this.state.attachmentFile}
            attachmentFileExtension={this.state.attachmentFileExtension}
            closeAttachment={this.closeAttachment}
          />
        }

        {
          this.state.successModal &&
          <SuccessModal

            successModal={this.state.successModal}
            successModalType={this.state.successModalType}
            successMessage={this.state.successMessage}
            closeSuccessModal={this.closeSuccessModal}
          />
        }
      </div>
    );
  }
}

export default UpdateSummary;
